"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _headerUtils = require("./headerUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Dropdown = props => {
  const {
    dropdownList,
    t,
    offNavigation,
    dropdowns,
    setDropdowns
  } = props;
  const id = dropdownList.headerElement.id;
  function toggle(id) {
    setDropdowns(prevState => prevState.map((item, idx) => idx === id ? !item : false));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-dropdown-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-text con-text__link",
    onClick: () => {
      toggle(id);
    }
  }, t(dropdownList.headerElement.name), /*#__PURE__*/_react.default.createElement("button", {
    className: "con-text con-text__link--dropdown"
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: "con-dropdown__navigation".concat(dropdowns[id] ? '--see' : '--unsee')
  }, dropdownList.headerElement.buttons.map(item => {
    return /*#__PURE__*/_react.default.createElement(_headerUtils.HeaderLink, {
      t: t,
      item: item,
      offNavigation: offNavigation
    });
  })));
};
exports.Dropdown = Dropdown;
Dropdown.propTypes = {
  dropdownList: _propTypes.default.object,
  t: _propTypes.default.func,
  dropdowns: _propTypes.default.array,
  setDropdowns: _propTypes.default.func,
  offNavigation: _propTypes.default.func
};